import React, { useState } from 'react';
import { FiSearch, FiX } from 'react-icons/fi';

type SearchProps = {
  placeholder: string;
  onSearchChange: (value: string) => void;
};

const Search: React.FC<SearchProps> = ({ placeholder, onSearchChange }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    onSearchChange(event.target.value);
  };

  const clearSearch = () => {
    setSearchTerm('');
    onSearchChange('');
  };

  return (
    <div className="flex justify-center items-center w-full">
      <div className="relative w-full">
        <input
          type="text"
          placeholder={placeholder}
          className="form-input h-10 border border-neutral/50 text-caption text-neutral/300 focus:outline-none focus:border-neutral/75 rounded-md w-full pl-3 pr-10"
          value={searchTerm}
          onChange={handleInputChange}
        />
        {searchTerm ? (
          <FiX
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-neutral/75 cursor-pointer"
            size={20}
            onClick={clearSearch}
          />
        ) : (
          <FiSearch
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-neutral/75"
            size={20}
          />
        )}
      </div>
    </div>
  );
};

export default Search;
